<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div v-if="activitydata.length!==0 && lableindex==0">
      <div class="nav" v-for="(item,index) in activitydata" :key="index">
        <div class="navtop">
          <div>微课评比</div>
          <div>{{item.name}}</div>
        </div>
        <div class="navmetter">
          <div>
            <div>活动主办单位：{{item.deptname}}</div>
            <div>活动时间：{{item.begintime}} 至 {{item.endtime}}</div>
          </div>
          <div>
            <div>活动状态：
              <span v-if="item.timestate==2">进行中</span>
              <span v-else-if="item.timestate==1">未开始</span>
              <span v-else-if="item.timestate==3">已结束</span>
            </div>
            <div>
              报名方式：
              <span v-if="item.way==1">指定名单</span>
              <span v-else-if="item.way==2">指定部门</span>
              <span v-else-if="item.way==3">公开报名</span>
            </div>
          </div>
        </div>
        <div class="navfoot">
          <div>
            <div>
              <el-button type="primary" size="small" @click="btnSubmit(item.id,item)">活动详情</el-button>
            </div>
            <div>
              <el-button type="success" :disabled="item.timestate!==2 && item.isSubmit" size="small" @click="apply(item.id,index,item)">立即报名</el-button>
            </div>
            <!-- v-if="item.isPj" -->
            <el-button type="success" size="small"  v-if="item.isPj"  @click="graded(item.id)">评分</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activitydata.length!==0 && lableindex==1">
      <el-table
            :data="jiluData"
            style="width: 100%; font-size: 16px"
          >
          <el-table-column
              prop="filename"
              label="状态"
              show-overflow-tooltip
              min-width="80"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.ispj" type="success">已评分</el-tag>
                <el-tag v-else type="info">未评分</el-tag>
              </template>
            </el-table-column>

            <el-table-column
              prop="filename"
              label="作品名称"
              show-overflow-tooltip
              min-width="200"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.filename }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="pjusername"
              label="批改者"
              show-overflow-tooltip
              min-width="120"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="score"
              label="分数"
              min-width="80"
              align="center"
            >
            </el-table-column>

            <el-table-column
              label="操作"
              min-width="80"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="primary" @click="newsVideo(scope.row)" size="mini">查看</el-button>
              </template>
            </el-table-column>

      </el-table>
    </div>

    <div v-if="activitydata.length==0" style="margin-top:20px">
      <nodata></nodata>
    </div>
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.Page"
        :page-size="listQuery.Limit"
        layout=" total,prev, pager, next,jumper"
        :total="listQuery.count"
        v-if="listQuery.count>0"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="dialogVisibleGrade" width="1250px">
      <!-- <div class="dialogheader">评分</div>

      <div class="table">
        <div>
          <div
            v-for="(item,index) in labledatapingf"
            :key="index"
            :class="{heightlight : lableindexpingf==index}"
            @click="lableAreapingf(index,item)"
          >{{item}}</div>
        </div>
        <div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="createName" label="作者" width="180"></el-table-column>
            <el-table-column prop="fileName" label="作品名称"></el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.isPj==false">
                  <el-tag type="info">未评分</el-tag>
                </span>
                <span v-else-if="scope.row.isPj==true">
                  <el-tag type="success">已评分</el-tag>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClickpingf(scope.row.id)" type="text" size="small">立即评分</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            v-if="listQuerypingf.limit>10"
            background
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChangepingf"
            @current-change="handleCurrentChangepingf"
            :current-page.sync="listQuerypingf.page"
            :page-size="listQuerypingf.limit"
            layout=" total,prev, pager, next,jumper"
            :total="listQuerypingf.count"
          ></el-pagination>
        </div>
      </div>-->
      <workscoring :GradeId="GradeId"></workscoring>
      <div class="pagination">
        <!-- <el-button type="primary" @click="submitres">保存</el-button> -->
        <el-button @click="dialogVisibleGrade = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 立即评分 -->
    <el-dialog :visible.sync="dialogVisibleCraderlit" width="50%">
      <continuetask ref="contMychird" :crderId="crderId"></continuetask>

      <div class="pagination">
        <el-button type="primary" @click="submitGrder">确认</el-button>
        <el-button @click="dialogVisibleCraderlit = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 报名 -->
    <el-dialog :show-close="false" :visible.sync="dialogVisible" width="50%">
      <div class="dialogheader">评比活动报名</div>
      <div class="dialogForm">
        <el-form :model="activityForm" ref="activityForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="参赛者">
            <el-input v-model="activityForm.createName" :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item label="手机号">
            <el-input v-model="activityForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="activityForm.email"></el-input>
          </el-form-item>-->
          <el-form-item label="活动作品">
            <el-upload
              :headers="headers"
              class="upload-demo"
              action="/resource/File/UploadFile"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :limit="1"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div>
              <div>
                <span>大小：不超过300M;</span>
                <span style="margin-left:50px">视频格式：MP4、FLV、AVI;</span>
              </div>
              <div>
                <span>图片格式：JPG、PNG;</span>
                <span style="margin-left:50px">文档格式：Word、Excel、PPT</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="pagination">
        <el-button type="primary" @click="submitres">保存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as personcen from '@/api/personcenter/index.js';
import continuetask from './component/continuetask.vue';
import workscoring from './component/workscoring';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    continuetask,
    workscoring,
  },
  data() {
    return {
      crderId: 0,
      dialogVisibleCraderlit: false,
      tableData: [],
      labledatapingf: ['未完成', '已完成'],
      lableindexpingf: 0,
      GradeId: 0,
      currentPage2: 1,
      labledata: ['活动列表', '活动记录'],
      lableindex: 0,
      dialogVisible: false,
      activityForm: {
        phone: '',
        email: '',
        fileUrl: '',
        fileName: '',
        activityId: 0,
        createId: JSON.parse(getInfo('infos')).id,
        createName: JSON.parse(getInfo('infos')).name,
      },
      userId: JSON.parse(getInfo('infos')).id,
      dialogVisibleGrade: false,
      activitydata: [],
      listQuerypingf: {
        page: 1,
        limit: 10,
        count: 0,
        activityId: 0,
      },
      listQuery: {
        Page: 1,
        Limit: 5,
        count: 0,
        Status:1,
        UserId:JSON.parse(getInfo('infos')).id
      },
      uploadData: [
        // {
        //     uploadname:'',
        //     uploadsize:'',
        //     uploadformat :'',
        // }
      ],
      jiluData:[],
      isSubmit:false

    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
  },
  created() {
    this.getlist();
  },
  methods: {
    newsVideo(data) {
      this.$router.push({
        path:'/personCenter/gradedafen',
        query:{
          id: data.id,
          ispj:0,
          activityid: data.activityid,
        }
      });
    },
    //评分记录
    getSelf(){
      
      personcen.getSelf({userid:JSON.parse(getInfo('infos')).id}).then((res)=>{
        this.jiluData=res.result
        this.listQuery.count=0
      })
    },
    // 评分保存
    submitGrder() {
      this.$refs.contMychird.submit();
    },
    // 立即评分
    handleClickpingf(val) {
      this.crderId = val;
      localStorage.setItem('resourceId', val);
      this.dialogVisibleCraderlit = true;
    },
    // 评分
    graded(val) {
      // this.GradeId = val;
      // this.getlistpfeng();
      // this.dialogVisibleGrade = true;
      this.$router.push({
        path: '/personCenter/grade',
        query: {
          id: val,
        },
      });
    },

    getlistpfeng() {
      this.listQuerypingf.activityId = this.GradeId;
      personcen.LoadActivityResource(this.listQuerypingf).then((res) => {
        this.tableData = res.data;
        this.listQuerypingf.count = res.count;
      });
    },
    lableAreapingf(index, item) {
      this.lableindexpingf = index;
    },
    handleSizeChangepingf(val) {
      this.listQuery.limit = val;
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChangepingf(val) {
      // console.log(`当前页: ${val}`);
      this.listQuery.page = val;
      this.getlistpfeng();
    },

    getlist() {
      personcen.getLoadQT(this.listQuery).then((res) => {
        this.activitydata = res.data;
        res.data.forEach((element, index) => {
          let star = element.begintime.slice(0, 10);
          this.activitydata[index].begintime = star;
          let end = element.endtime.slice(0, 10);
          this.activitydata[index].endtime = end;
        });
        this.listQuery.count = res.count;
      });
    },
    lableArea(index, item) {
      this.lableindex = index;
      if(index==0){
        this.listQuery.page = 1
        this.getlist()
      }else{
        this.getSelf()
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.listQuery.Limit = val;
    },
    handleCurrentChange(val) {
      this.listQuery.Page = val;
      this.getlist();
      // console.log(`当前页: ${val}`);
    },
    btnSubmit(id,item) {
      this.$router.push({
        path: '/mooc/moocAppraise',
        query: {
          id: id,
          isSubmit:item.isSubmit
        },
      });
    },
    apply(id, index,item) {
      localStorage.setItem('activityId', id);
      if (this.activitydata[index].way == 3) {
        this.activityForm = {
          phone: '',
          email: '',
          fileUrl: '',
          fileName: '',
          activityId: id,
          createId: JSON.parse(getInfo('infos')).id,
          createName: JSON.parse(getInfo('infos')).name,
        };
        // localStorage.setItem('activityId', this.$route.query.id);
        this.dialogVisible = true;
      } else {
        
        if(item.isSubmit){
          let para={
            activityId:id,
            userId:JSON.parse(getInfo('infos')).id
          }
          personcen.isUpload(para).then((res)=>{
            if(res.result){
              this.$message.warning('您已报名和上传作品！');
            }else{
              this.activityForm = {
                phone: '',
                email: '',
                fileUrl: '',
                fileName: '',
                activityId: id,
                createId: JSON.parse(getInfo('infos')).id,
                createName: JSON.parse(getInfo('infos')).name,
              };
              this.dialogVisible = true;
            }
          })
          
        }else{
          this.$message.warning('您不是本次活动参赛人员，无法参加活动！');
        }
        
      }
      // this.dialogVisible = true;
    },
    handleSuccess(res, file, fileList) {
      // console.log(res.result);
      // console.log(file);
      // console.log(fileList);
      this.activityForm.fileUrl = res.result;
      this.activityForm.fileName = file.name;
      let filePath = res.result.lastIndexOf('.');
      let a = {
        uploadname: file.name,
        uploadformat: res.result.substr(filePath + 1),
      };
      this.uploadData.push(a);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    submitres() {
      if (this.activityForm.fileUrl == '') {
        this.$notify({
          title: '警告',
          message: '请先上传作品',
          type: 'warning',
        });
      } else {
        this.activityForm.activityId = localStorage.getItem('activityId');
        personcen.AddActivityResource(this.activityForm).then((res) => {
          this.$notify({
            title: '成功',
            message: '上传成功',
            type: 'success',
          });
          localStorage.removeItem('activityId');
          this.dialogVisible = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.content {
  /* width: 900px; */
  /* height: 1000px; */
  width: 100%;
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.nav {
  width: 900px;
  height: 200px;
  /* box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */
  border-radius: 10px;
  border: 1px solid #f2f2f2;
  margin: 0 auto;
  margin-top: 20px;
}
.navtop {
  height: 50px;
  display: flex;
  border-bottom: 1px solid #f2f2f2;
}
.navtop > div:nth-child(1) {
  width: 64px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
  margin-top: 10px;
  background-color: rgb(248, 185, 10);
  border-radius: 5px;
  color: #fff;
}
.navtop > div:nth-child(2) {
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  font-weight: 700;
  font-size: 16px;
  margin-left: 20px;
}
.navmetter {
  height: 100px;
  border-bottom: 1px solid #f2f2f2;
}
.navmetter > div {
  display: flex;
}
.navmetter > div > div:nth-child(1) {
  flex: 1;
  margin-top: 20px;
  margin-left: 20px;
}
.navmetter > div > div:nth-child(2) {
  flex: 1;
  margin-top: 20px;
  margin-left: 20px;
}
.navfoot {
  height: 60px;
}
/* .navfoot>div{
    margin-left: 650px;
    margin-top: 5px;
} */
.navfoot > div {
  margin-left: 500px;
  margin-top: 5px;
  display: flex;
}
.navfoot > div > div {
  width: 110px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
/deep/.el-dialog__header {
  height: 0px;
}
.dialogheader {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
}
.dialogForm {
  width: 90%;
  margin-top: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>